import React from 'react';
import { cn } from '@/lib/utils';
import { useTheme } from '@/contexts/ThemeContext';
interface SearchEmptyStateProps {
  query: string;
  isSearching: boolean;
}
const SearchEmptyState: React.FC<SearchEmptyStateProps> = ({
  query,
  isSearching
}) => {
  const {
    resolvedTheme
  } = useTheme();
  const isDark = resolvedTheme === 'dark';
  if (query.length === 0) {
    return;
  }
  if (isSearching) {
    return <div className="text-center py-8">
        <div className="inline-block h-6 w-6 animate-spin rounded-full border-2 border-solid border-current border-r-transparent" />
        <p className={cn("mt-4 font-serif", isDark ? "text-zinc-400" : "text-zinc-500")}>Searching...</p>
      </div>;
  }
  return <div className="text-center py-8">
      <p className={cn("text-lg font-serif", isDark ? "text-zinc-400" : "text-zinc-500")}>
        No results found for "{query}"
      </p>
      <p className={cn("mt-2 text-sm", isDark ? "text-zinc-500" : "text-zinc-400")}>
        Try different keywords or browse our categories
      </p>
    </div>;
};
export default SearchEmptyState;